import React, { useState } from 'react';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import { doSwaggerCall } from '../../hooks/useSwaggerClient';

const uploadAgents = async (clientId, agents) => {
    const ret = {
        success: 0,
        errors: []
    };
    for (let i = 0; i < agents.length; i++) {
        try {
            // FIXME: move it to createUser + changeRole
            await doSwaggerCall('users', 'createUser', {
                user: {
                    ...agents[i],
                    client_id: parseInt(clientId, 10),
                    sentRole: 'agent',
                    send_welcome_email: true
                }
            });
            ret.success++;
        } catch (err) {
            ret.errors.push(
                `${agents[i]?.email} - ${err?.response?.body?.message || err.toString()}`
            );
        }
    }
    return ret;
};

const AddAgentDialog = ({ showModal, MODAL_TYPE, clientId, agents }) => {
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errors, setErrors] = useState([]);
    const onClose = () => showModal(MODAL_TYPE.NONE);

    return (
        <Dialog aria-labelledby="agent-list-upload-modal" open onClose={onClose}>
            <DialogTitle>Agent List Upload</DialogTitle>
            <DialogContent>
                {agents
                    ? `Do you want to add ${agents.length} agent${
                          agents.length !== 1 ? 's' : ''
                      } to this client?`
                    : `${success} agent${
                          success !== 1 ? 's were' : ' was'
                      } successfully added to this client!`}

                {errors && errors.length > 0 && (
                    <div>
                        The following errors occured:
                        {errors.map(error => (
                            <div key={error}>{error}</div>
                        ))}
                    </div>
                )}
            </DialogContent>
            <DialogActions>
                <Button variant="contained" disabled={loading} onClick={onClose}>
                    Close
                </Button>
                {agents && !loading && errors.length === 0 && success === false && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setLoading(true);
                            uploadAgents(clientId, agents).then(({ success, errors }) => {
                                setSuccess(success);
                                setErrors(errors);
                                setLoading(false);
                            });
                        }}
                    >
                        Yes
                    </Button>
                )}
                {loading && <CircularProgress />}
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(AddAgentDialog);
